export enum CommunicationsResponseGetConversationLogPIIError {
  unableToGetConversationLog = 'unableToGetConversationLog',
  unableToGetPII = 'unableToGetPII',
}
